<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    {{ race_series_obj }}
    <div class="position-relative" style="z-index: 10">
      <div class="w100 mb-5">
        <div class="row mb-3">
          <div class="col-4">
            <label for="Label" class="form-label">名称</label>
            <input
              type="text"
              class="form-control"
              id="Label"
              placeholder="名称"
              v-model="race_series_obj.label"
            />
          </div>
          <div class="col-2">
            <label for="DistrictCd" class="form-label">シリーズコード</label>
            <input
              type="text"
              class="form-control"
              id="SerisCd"
              placeholder="シリーズコード"
              v-model="race_series_obj.race_series_cd"
            />
          </div>
          <div class="col-2">
            <label for="Sort" class="form-label">sort</label>
            <input
              type="number"
              class="form-control"
              id="Sort"
              placeholder="ソート"
              v-model="race_series_obj.sort"
            />
          </div>
          <div class="col-3">
            <label for="UpperLicenseCd" class="form-label">競技種目</label>
            <bs-select
              :options="license_event_cd_list"
              v-model="race_series_obj.license_event_id"
              :null-option="false"
              id=""
              :PrefCd="'form-select'"
            ></bs-select>
          </div>
        </div>
        <div class="row mb-3">
          <label for="RaceTypeCd" class="form-label">格式</label>
          <div class="col-12">
            <div
              class="d-inline-block mb-1 me-2"
              v-for="race_type in race_type_cd_obj_list"
              :key="race_type"
            >
              <button
                :class="attach_obj_class(race_type.id, 'type')"
                @click="input_check_obj(race_type.id, 'type')"
              >
                <i
                  class="bi bi-check-square"
                  v-if="attach_obj(race_type.id, 'type')"
                ></i>
                <i class="bi bi-square" v-else></i> {{ race_type.label }}
              </button>
            </div>
          </div>
        </div>
        <div class="row mb-3" v-if="race_series_obj.license_event_id">
          <label for="RaceTypeCd" class="form-label">クラス</label>
          <div
            class="col-12"
            v-if="
              typeof race_class_data_obj_list_filter === 'object' &&
              race_class_data_obj_list_filter.length > 0
            "
          >
            <div
              class="d-inline-block mb-1 me-2"
              v-for="race_class in race_class_data_obj_list_filter"
              :key="race_class"
            >
              <button
                :class="attach_obj_class(race_class.id, 'class')"
                @click="input_check_obj(race_class.id, 'class')"
              >
                <i
                  class="bi bi-check-square"
                  v-if="attach_obj(race_class.id, 'class')"
                ></i>
                <i class="bi bi-square" v-else></i> {{ race_class.label }}
              </button>
            </div>
          </div>
          <div v-else>
            <p class="alert alert-warning">
              競技種目に設定されたクラスが存在しません。
            </p>
          </div>
        </div>
        <div v-else>
          <p class="alert alert-warning">競技種目を選択して下さい。</p>
        </div>
      </div>
      <!-- {{race_series_obj.license_exclude}} -->
    </div>
    <div
      class="position-sticky bottom-0 bg-light pt-3 pb-2 px-2 border rounded-1"
      style="z-index: 110"
    >
      <div class="row mb-3">
        <div class="col-12 col-sm-4 mb-2">
          <button
            type="submit"
            @click="back"
            class="btn btn-light btn-outline-secondary"
          >
            戻る
          </button>
        </div>
        <div class="col-12 col-sm-4 mb-2 text-center">
          <button type="submit" @click="update" class="btn btn-primary">
            {{ btnLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
import BsSelect from '../../atoms/BsSelect.vue'
// import '../../assets/bootstrap/css/sc.css';
import axios from 'axios'
import config from '../../../const'

export default {
  name: 'LicenseCdDetailView',
  data: function () {
    return {
      targetid: this.$route.params.id,
      fromParentTitle: 'シリーズデータ',
      fromParentBtn: '',
      alertMessage: '',
      alertClass: 'alert-info',
      btnLabel: '',
      license_event_cd_obj: [],
      license_class_obj: [],
      license_category_obj: [],
      race_type_cd_obj: [],
      race_class_data_obj: [],
      race_series_obj: {},
      race_series_list_obj: [],
      default_add_price_obj: {
        id: 0,
        stat: 0,
        license_id: this.$route.params.id,
        target_id: 0,
        price: 0
      },
      default_license_exclude_obj: {
        id: 0,
        stat: 0,
        license_id: this.$route.params.id,
        target_id: 0
      },
      default_test_obj: {
        id: 0,
        stat: 1,
        license_id: this.$route.params.id,
        label: '',
        options: []
      },
      default_test_option_obj: {
        id: 0,
        stat: 1,
        license_id: this.$route.params.id,
        test_id: 0,
        label: '',
        correct: 0
      },
      sales_flg_list: [
        {
          key: 0,
          label: '販売しない'
        },
        {
          key: 1,
          label: '販売'
        }
      ],
      require_list: [
        {
          key: 0,
          label: '未設定'
        },
        {
          key: 1,
          label: '設定する'
        }
      ]
    }
  },
  components: {
    BsPageTitle,
    BsSelect,
    BsMsgAlert
    // BsButton,
    // BsCheckBox,
  },
  methods: {
    async input_check_obj(target_id, type) {
      const tmps = { ...this.race_series_obj }
      const relations = [...tmps[type + '_relation']]
      const target_column = type == 'type' ? 'race_type_id' : 'class_id'
      const series_column = type == 'type' ? 'race_series_id' : 'series_id'
      if (this.attach_obj(target_id, type) == true) {
        const idx = relations.findIndex(
          relation => parseInt(target_id) == parseInt(relation[target_column])
        )
        relations.splice(idx, 1)
      } else {
        relations.push({
          id: 0,
          [target_column]: target_id,
          [series_column]: this.not_add ? this.targetid : 0
        })
      }
      tmps[type + '_relation'] = relations
      this.race_series_obj = tmps
    },
    async loadRaceSeriesList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_series_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceSeriesList response', response)
          if (response.data && response.data.body) {
            this.race_series_list_obj = response.data.body.map(list => {
              if (this.attach_target_license_price(list.id)) {
                list.set_price = this.attach_target_license_price(list.id)
              } else {
                list.set_price = 0
              }
              return list
            })
          } else {
            this.race_series_list_obj = []
          }
        })
        .catch(async err => {
          console.log(err)
          this.race_series_list_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdObj() {
      const params = {}
      await axios
        .post(
          config.BASE_API_URL + '/license_event_cd/lists',
          this.setParams_S(params),
          this.cHeader
        )
        .then(async response => {
          console.log('loadLicenseEventCdObj', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceTypeCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_type_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceTypeCdList response', response)
          this.race_type_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_type_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceClassDataList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/race_class_data/lists',
        params
      )
        .then(async response => {
          console.log('loadRaceClassDataList response', response)
          this.race_class_data_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log('license_cd', err)
          this.race_class_data_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRaceSerisObj() {
      const params = {}
      params['id'] = this.targetid
      await axios
        .post(
          config.BASE_API_URL + '/race_series_cd/lists',
          this.setParams_S(params),
          this.cHeader
        )
        .then(async response => {
          console.log('loadRaceSerisObj', response)
          this.race_series_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
        })
        .catch(async err => {
          console.log(err)
          this.race_series_obj = {}
        })
        .finally(async () => {
          await this.loadRaceSeriesList()
          this.$forceUpdate()
        })
    },
    async update() {
      const params = this.race_series_obj
      console.log('update params', params)
      const post_url = this.not_add
        ? config.BASE_API_URL + '/race_series_cd/edit/' + this.targetid
        : config.BASE_API_URL + '/race_series_cd/add'
      let result = true
      await this.basicPosts_I(post_url, params)
        .then(async response => {
          console.log('update race_series_cd response', response)
          if (
            typeof response === 'object' &&
            response.data &&
            response.data &&
            response.data.status == '200'
          ) {
            this.alertMessage = this.btnLabel + 'しました'
            this.alertClass = 'alert-success'
            this.targetid = response.data.body.id
          } else if (
            typeof response === 'object' &&
            typeof response.data === 'object' &&
            response.data.status == '500'
          ) {
            console.log(
              'error update status 500',
              response.data.alert.error_obj
            )
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
            if (typeof response.data.alert.error_obj === 'object') {
              const tmp_error = { ...this.member_error_obj }
              Object.keys(response.data.alert.error_obj).forEach(key => {
                tmp_error[key] = response.data.alert.error_obj[key]
              })
              this.race_series_obj = tmp_error
            }
          } else {
            this.alertMessage = this.btnLabel + 'できませんでした'
            this.alertClass = 'alert-danger'
            result = false
          }
        })
        .catch(err => {
          console.log(err)
          this.alertMessage = this.btnLabel + 'できませんでした'
          this.alertClass = 'alert-danger'
        })
        .finally(async () => {
          if (result) await this.loadRaceSerisObj()
          this.$forceUpdate()
          alert(this.alertMessage + ':' + result + ':' + this.targetid)
        })
    },
    // async update() {
    //   console.log('component methods', this.race_series_list_obj);

    //   return this.$store
    //     .dispatch('updateBasic', {
    //       data: this.race_series_obj,
    //       target: 'race_series_cd',
    //     })
    //     .then(() => {
    //       this.alertMessage = this.btnLabel + 'しました';
    //       this.alertClass = 'alert-success';
    //     })
    //     .catch((err) => {
    //       Promise.reject(err);
    //       this.alertMessage = this.btnLabel + 'できませんでした';
    //       this.alertClass = 'alert-danger';
    //     })
    //     .finally(async () => {
    //       await this.loadLicenseCdObj();
    //     });
    // },
    back() {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({}),
    not_add: function () {
      return this.targetid != 'add' && !Number.isNaN(this.targetid)
        ? true
        : false
    },
    attach_obj: function () {
      const series_obj = this.race_series_obj
      return function (target_id, type) {
        const target_column = type == 'type' ? 'race_type_id' : 'class_id'
        if (
          typeof series_obj === 'object' &&
          typeof series_obj[type + '_relation'] === 'object' &&
          series_obj[type + '_relation'].find(
            relation => relation[target_column] == target_id
          )
        ) {
          return true
        }
        return false
      }
    },
    attach_obj_class: function () {
      const attach = this.attach_obj
      return function (target_id, type) {
        if (attach(target_id, type)) {
          return 'btn btn-sm btn-primary'
        }
        return 'btn btn-sm btn-dark'
      }
    },
    attach_target_license: function () {
      const add_price = (this.race_series_obj || {}).add_price
      return function (target_id) {
        if (
          typeof add_price === 'object' &&
          add_price.find(obj => obj.target_id == target_id)
        ) {
          return add_price.find(obj => obj.target_id == target_id)
        }
        return false
      }
    },
    attach_target_license_stat: function () {
      const attach = this.attach_target_license
      return function (target_id) {
        const obj = attach(target_id)
        if (typeof obj === 'object') {
          return parseInt((obj || {}).stat)
        }
        return false
      }
    },
    attach_target_license_price: function () {
      const attach = this.attach_target_license
      return function (target_id) {
        const obj = attach(target_id)
        if (typeof obj === 'object') {
          return parseInt((obj || {}).price)
        }
        return false
      }
    },
    chk_license_from_class: function () {
      const lists = [...this.race_series_list_obj]
      return function (license_class) {
        if (lists.find(list => list.license_class == license_class)) {
          return true
        }
        return false
      }
    },
    chk_license_from_license_event_id_and_class: function () {
      const lists = this.race_series_list_obj
      return function (license_event_id, license_class) {
        if (
          typeof lists === 'object' &&
          lists.find(list => {
            if (
              license_event_id == list.license_event_cd &&
              license_class == list.license_class
            ) {
              return true
            }
            return false
          })
        ) {
          return true
        }
        return false
      }
    },
    set_price_btn_class: function () {
      const attach = this.attach_target_license_stat
      return function (target_id) {
        const obj = attach(target_id)
        if (obj === 1) {
          return 'btn btn-info'
        }
        return 'btn btn-light btn-outline-secondary'
      }
    },
    set_price_icon_class: function () {
      const attach = this.attach_target_license_stat
      return function (target_id) {
        const obj = attach(target_id)
        if (obj === 1) {
          return 'bi bi-check-square'
        }
        return 'bi bi-square'
      }
    },
    license_event_cd_list: function () {
      const license_event_cd = this.license_event_cd_obj
      return license_event_cd.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    },
    race_type_cd_obj_list: function () {
      return this.race_type_cd_obj
    },
    race_class_data_obj_list: function () {
      return this.race_class_data_obj
    },
    race_class_data_obj_list_filter: function () {
      if (this.race_series_obj.license_event_id) {
        return this.race_class_data_obj.filter(class_data => {
          if (
            class_data.license_event_id == this.race_series_obj.license_event_id
          ) {
            return true
          }
          return false
        })
      }
      return []
    },
    license_class_list: function () {
      const lists = [...this.license_class_obj]
      return lists
    },
    license_category_list: function () {
      const lists = [...this.license_category_obj]
      return lists
    },
    get_license_data: function () {
      const cd_list = this.race_series_list_obj
      return function (license_cd) {
        return cd_list.find(liense => liense.liense_cd == license_cd)
      }
    },
    get_license_param: function () {
      const get_func = this.get_license_data
      return function (license_cd, param) {
        if (
          typeof get_func(license_cd) === 'object' &&
          (typeof get_func(license_cd)[param] === 'string' ||
            typeof get_func(license_cd)[param] === 'number')
        ) {
          return get_func(license_cd)[param]
        }
        return ''
      }
    },
    license_cd_filter: function () {
      const lists = [...this.race_series_list_obj]
      return function (license_event_id, license_class) {
        return lists
          .filter(list => {
            if (
              list.id != this.targetid &&
              license_event_id == list.license_event_cd &&
              license_class == list.license_class
            ) {
              return true
            }
            return false
          })
          .sort((a, b) => {
            if (parseInt(a.sort) < parseInt(b.sort)) {
              return -1
            } else {
              return 1
            }
          })
      }
    },
    license_cd_list: function () {
      const lists = [...this.race_series_list_obj]
      return lists
        .filter(list => {
          if (list.id != this.targetid) {
            return true
          }
          return false
        })
        .map(list => {
          list.key = list.license_id
          // list.set_price = 0;
          list.upper_license_label = this.get_license_param(
            list.upper_license_cd,
            'short_label'
          )
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    license_cd_list_filters: function () {
      const tmps = this.license_cd_list
      return function (license_category, license_event_id) {
        const lists = tmps
        return [...lists]
          .filter(list => {
            if (license_category == false) {
              return true
            } else if (
              typeof license_category === 'object' &&
              license_category.includes(parseInt(list.license_category))
            ) {
              return true
            } else if (list.license_category == license_category) {
              return true
            }
          })
          .filter(list => {
            if (license_event_id == false) {
              return true
            } else if (list.license_event_cd == license_event_id) {
              return true
            }
          })
          .map(list => {
            list.key = list.id
            return list
          })
          .sort((a, b) => {
            if (parseInt(a.sort) < parseInt(b.sort)) {
              return -1
            } else {
              return 1
            }
          })
      }
    }
  },

  async created() {
    await this.loadLicenseEventCdObj()
    await this.loadRaceTypeCdList()
    await this.loadRaceClassDataList()
    if (Number.isNaN(this.targetid)) {
      this.$router.push({ path: '/' })
    } else if (this.targetid != 'add' && !Number.isNaN(this.targetid)) {
      this.loadRaceSerisObj()
      this.btnLabel = '更新'
    } else {
      this.race_series_obj = {
        id: 0,
        label: '',
        race_series_cd: '',
        license_event_id: '',
        app_start_date: '',
        app_end_date: '',
        sort: '',
        relations: []
      }
      this.btnLabel = '登録'
      await this.loadRaceSeriesList()
    }
    this.alertMessage = this.btnLabel + 'できます'
  },
  mounted: function () {
    this.fromParentTitle = 'シリーズデータ詳細'
    // console.log('tags_list', this.tags_list);
  },
  props: {}
}
</script>
